import { IssueType, IssueTypeEnum } from '@issuemanager/constants';
import { useTranslation } from 'react-i18next';

export function useLocalizedIssueTypes() {
  const { t } = useTranslation('common');
  return {
    [IssueTypeEnum.AUDIT_FINDING]: t('issueTypes.auditFinding'),
    [IssueTypeEnum.CONTROL_DEFICIENCY]: t('issueTypes.controlDeficiency'),
    [IssueTypeEnum.ISSUE]: t('issueTypes.issue'),
    [IssueTypeEnum.INCIDENT]: t('issueTypes.incident'),
    [IssueTypeEnum.EXCEPTION]: t('issueTypes.exception'),
  };
}

export type IssueTypeData = {
  id: string;
  value: IssueType;
  label: string;
};
